const IconCircleCheck = (props) => {
  const {
    width = 24,
    height = 24,
    enableViewBox = true,
    circleAxis = 12,
    checkFillColor = "fill-[#FFF]",
    circleFillColor = "fill-[#00931F]",
    circleStroke = "stroke-none",
    outerFillColor = "fill-none",
    customViewBox,
    ...otherProps
  } = props;
  return (
    <svg
      width={width}
      height={height}
      {...(enableViewBox && {
        viewBox: customViewBox || `0 0 ${width} ${height}`,
      })}
      {...otherProps}
    >
      <g className={outerFillColor} fillRule="evenodd">
        <circle
          className={`${circleFillColor} ${circleStroke}`}
          cx={circleAxis}
          cy={circleAxis}
          r={circleAxis}
        />
        <path d="M6.167 6.167h11.667v11.667H6.167z" />
        <path
          d="M10.307 16.106l-3.43-3.43a.528.528 0 010-.747l.746-.747a.528.528 0 01.747 0l2.31 2.311 4.95-4.95a.528.528 0 01.747 0l.746.747a.528.528 0 010 .746l-6.07 6.07a.528.528 0 01-.746 0z"
          className={checkFillColor}
        />
      </g>
    </svg>
  );
};

export default IconCircleCheck;
